import React, { useContext, useEffect, useMemo } from 'react';
import { localText } from 'langs/fa/data-grid';

//Material UI
import { LinearProgress, makeStyles } from '@material-ui/core';

//Zustands
import { useMainStore } from 'useStores/useMainStore';
import UserDetailsFilters from './UserDetailsFilters';
import { useOnlineUsersStore } from './useOnlineUsersStore';

//Packages
import moment from 'moment-jalaali';

//Utils
import { __ } from 'utils/i18n';

//Functions
import { toEN } from 'fns';
import { formatNumber } from 'fns';
import { rond } from 'fns';
import { toFA } from 'fns/toFA';

//Components
import DataGrid from 'components/DataGrid/DataGrid';
import Total from '../../../../../components/Total/Total';
import useTitle from 'hooks/useTitle';
import { store as reportStore } from '../reducer';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridGap: theme.spacing(1),
  },
}));

const UserDetails = () => {
  useTitle('گزارش کاربر');
  const classes = useStyles();
  const users = useOnlineUsersStore((state) => state.selectedUser);
  const history = useHistory();
  const isMobile = false;
  const page = 1;
  const limit = useMainStore((state) => state.limit);
  const isLoading = useOnlineUsersStore((state) => state.isLoadingUser);
  const changePage = useOnlineUsersStore((state) => state.changeUserPage);
  const totalAmount = useOnlineUsersStore(
    (state) => state.selectedUser?.totalAmount
  );
  const onlineTotal = useOnlineUsersStore(
    (state) => state.selectedUser?.onlineTotal
  );
  const offlineTotal = useOnlineUsersStore(
    (state) => state.selectedUser?.offlineTotal
  );
  const { dispatch: reportDispatch } = useContext(reportStore);

  const columns = useMemo(
    () => [
      {
        field: 'row',
        sortable: false,
        headerName: 'ردیف',
        width: 90,
        renderCell: ({ value }) => <div>{toFA(value)}</div>,
      },
      {
        field: 'loadingDate',
        sortable: false,
        headerName: 'تاریخ بارگیری',
        width: 200,
        renderCell: ({ value }) => (
          <div>
            {!!value ? moment(value).format('dddd jYYYY/jMM/jDD ') : '-'}
          </div>
        ),
      },
      {
        field: 'departure',
        sortable: false,
        headerName: 'مبدا',
        width: 200,
        renderCell: ({ value }) => <div>{value}</div>,
      },
      {
        field: 'waybillType',
        sortable: false,
        headerName: 'نوع بارنامه',
        width: 150,
        renderCell: ({ value }) => <div>{__(`_${value}`)}</div>,
      },
      {
        field: 'companyCommission',
        sortable: false,
        headerName: 'کارمزد شرکت',
        flex: 1,
        renderCell: ({ value }) => (
          <div>{!!value ? toFA(formatNumber(toEN(rond(value)))) : '-'}</div>
        ),
      },
      {
        field: 'onlineCommissions',
        sortable: false,
        headerName: 'کارمزد آنلاین',
        width: 150,
        renderCell: ({ value }) => (
          <div>{!!value ? toFA(formatNumber(toEN(rond(value)))) : '-'}</div>
        ),
      },
      {
        field: 'offlineCommission',
        sortable: false,
        headerName: 'کارمزد سنتی',
        width: 150,
        renderCell: ({ value }) => (
          <div>{!!value ? toFA(formatNumber(toEN(rond(value)))) : '-'}</div>
        ),
      },
    ],
    [users]
  );

  const handlePageChange = async (page) => {
    changePage(page);
  };

  useEffect(() => {
    reportDispatch({
      type: 'CHANGE_TITLE_CATEGORY',
      payload: {
        title: '',
        category: '',
      },
    });
  }, []);

  function handleSelectUser(id) {
    const { order } = users.docs.find((item) => item._id === id.row.id);
    history.push(`/protected/admin/orders/${order._id}`);
  }

  return (
    <div className={classes.root}>
      <UserDetailsFilters />
      {isLoading && <LinearProgress />}
      <div
        style={{
          width: '100%',
          position: 'relative',
          height: isMobile ? 'initial' : 480,
        }}
      >
        <DataGrid
          rows={
            users?.docs?.map((user, i) => ({
              id: user._id,
              row: (page - 1) * limit + i + 1,
              loadingDate: user.order?.loadDate,
              departure: user.order.origin.title,
              waybillType: user.order.waybillType,
              companyCommission: user.commission + '',
              offlineCommission: !user.online ? user.amount + '' : '',
              onlineCommissions: user.online ? user.amount + '' : '',
            })) || []
          }
          columns={columns}
          localeText={localText}
          onPageChange={handlePageChange}
          paginationMode="server"
          pageSize={limit}
          pageNumber={page * 1}
          rowCount={users?.totalDocs || 0}
          disableMultipleSelection
          density="compact"
          totalPages={users?.totalPages}
          defaultPage={page || 1}
          footerPagination={true}
          onCellClick={handleSelectUser}
        />
      </div>
      <div className="d-flex" style={{ gap: 8, position: 'sticky', bottom: 0 }}>
        <Total
          backgroundColor={'purple'}
          total={toFA(formatNumber(toEN(rond(totalAmount))))}
        />
        <Total
          backgroundColor={'yellow'}
          title="جمع کل آنلاین: "
          total={toFA(formatNumber(toEN(rond(onlineTotal))))}
        />
        <Total
          backgroundColor={'red'}
          title="جمع کل سنتی: "
          total={toFA(formatNumber(toEN(rond(offlineTotal))))}
        />
      </div>
    </div>
  );
};

export default UserDetails;
